import React, {useState} from "react";

import './RadioButtonGroup.scss';

const RadioButtonGroup = ({onChange, values, name, initialValue}) =>
{
   const [ selected, setSelected ] = useState ( initialValue ) ;
   const onRBhange = (e) =>
   {
      const { name, value } = e.target;

      setSelected(+value) ;

      onChange(+value) ;
   }

   const isSelected = (offset) =>
   {
      return selected === offset ;
   }

   const buttons = ( values ) =>
   {
      return values.map ((value, index) =>
      {
         const testValue = initialValue === null ? null : +initialValue ;

         return (
             <div className="form-check" key={index}>
                <input className="form-check-input" type="radio" defaultChecked={+value.offset === testValue} value={+value.offset} name={name} id={name + index } onClick={onRBhange}/>
                   <label className="form-check-label" htmlFor={name + index }>
                      {value.label}
                   </label>
             </div>
         )
      })
   }

   return (
      <div className="radio-group-ns" key='rnd'>
         {buttons(values)}
      </div>
   )
}
export { RadioButtonGroup } ;